import { END_POINT } from "constants/apiConstant";
import { apiGet, apiPost } from "../utils/apiUtils";

const {
  SAVE_ORDER,
  CART_LIST_API,
  CART_ADD_API,
  CART_ADD_ALL_API,
  CART_UPDATE_API,
  CART_REMOVE_API,
  CART_CLEAR_PARTNER_API,
  CART_CLEAR_API,
} = END_POINT;

/**
 * The order row OrdersController@create returns, with the Hub write-back
 * outcome attached (App\Services\HubDerive::afterOrder). The order is saved
 * either way; `hub_sync` reports, separately, whether the board's Hub page
 * heard about it (see utils/hubSyncWarning for the shape).
 *
 * @typedef {Object} OrderRecord
 * @property {number} id
 * @property {import("../utils/hubSyncWarning").HubSync} [hub_sync]
 */

export const saveOrder = async (payload) => {
  const response = await apiPost(SAVE_ORDER, payload);
  return response;
};

export const getCartAPI = async () => {
  return await apiGet(CART_LIST_API);
};

export const addCartItemAPI = async (item) => {
  return await apiPost(CART_ADD_API, { item });
};

export const addAllCartItemsAPI = async (items) => {
  return await apiPost(CART_ADD_ALL_API, { items });
};

export const updateCartItemAPI = async (id, item) => {
  return await apiPost(`${CART_UPDATE_API}${id}`, { item });
};

export const removeCartItemAPI = async (id) => {
  return await apiPost(`${CART_REMOVE_API}${id}`, {});
};

export const clearCartPartnerAPI = async (apiPartner) => {
  return await apiPost(CART_CLEAR_PARTNER_API, { api_partner: apiPartner });
};

export const clearCartAPI = async () => {
  return await apiPost(CART_CLEAR_API, {});
};
